// extracted by mini-css-extract-plugin
var _1 = "qIpB6";
export { _1 as "menuButton" }
